module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-09-26f341e87811a055548f135db489373d.png";